import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  footer: {
    marginVertical: indent * 0.6,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerGroup: {
    minWidth: 140,
  },
  footerGroupTitle: {
    marginBottom: indent * 0.2,
    color: codGray,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
